import { render, staticRenderFns } from "./PromotionUpsellModal.vue?vue&type=template&id=dd9587e4&"
import script from "./PromotionUpsellModal.vue?vue&type=script&lang=ts&"
export * from "./PromotionUpsellModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports